import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CmsService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { MyaccountPersonalInfoService } from 'src/app/service/myaccount/myaccount-personal-info.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { B2bunitService } from '../../../../service/b2bunit/b2bunit.service';
import { CheckoutServiceExtends } from '../../../../service/checkout/checkout.service';

@Component({
  selector: 'app-checkout-billing-address',
  templateUrl: './checkout-billing-address.component.html',
  styleUrls: ['./checkout-billing-address.component.scss'],
  standalone: false,
})
export class CheckoutBillingAddressComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  defaultBillingAddress$ = this.b2bUnitService.getB2BUnitAddresses();
  defaultBillingAddress: any;
  billingAddresses: any;
  currentDeliveryAddress: any;
  cartId$ = this.cartService.getActiveCartId();
  activeCart$: Observable<string> = this.cartService.getActiveCartId();
  cartId: any;
  hasChangedAddress$: Subscription;
  hasChangedAddress = false;

  constructor(
    protected b2bUnitService: B2bunitService,
    protected checkoutService: CheckoutServiceExtends,
    protected cartExtendService: CartExtendService,
    protected cartService: ActiveCartFacade,
    private cmsService: CmsService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    private myaccountPersonalInfoService: MyaccountPersonalInfoService
  ) {}

  ngOnInit() {
    this.cartId$.pipe(take(1)).subscribe((results) => {
      this.cartId = results;
    });
    this.hasChangedAddress$ = this.componentService.holdDeliveryAddress$.subscribe((status) => {
      this.hasChangedAddress = status;
    });
    setTimeout(() => {
      const cartEntires = this.componentService.checkoutCartEntries$.getValue();
      const cartPaymentAddress = this.componentService.checkoutCartEntriesPaymentAddress$.getValue();
      if (!this.hasChangedAddress) {
        if (cartEntires && cartPaymentAddress) {
          if (typeof cartPaymentAddress !== 'undefined') {
            this.currentDeliveryAddress = cartPaymentAddress;
          } else {
            this.getBillingAddress();
          }
        } else {
          this.getBillingAddress();
        }
        this.cmsService.getCurrentPage().subscribe((currentPage) => {
          if (currentPage && currentPage.template.includes('ShimanoCheckoutSummaryPageTemplate')) {
            if (!(this.cdr as ViewRef).destroyed) {
              this.cdr.detectChanges();
            }
          }
        });
      }
    }, 1000);
  }

  getBillingAddress() {
    if (this.storageService.getSessionStorageItem('baddID') !== null) {
      this.currentDeliveryAddress.formattedAddress = this.storageService.getSessionStorageItem('baddFormatted');
      this.currentDeliveryAddress.addressId = this.storageService.getSessionStorageItem('baddID');
    } else {
      this.defaultBillingAddress$.pipe(take(1)).subscribe((resdefault) => {
        if (resdefault) {
          if (
            typeof this.defaultBillingAddress !== 'undefined' &&
            typeof this.defaultBillingAddress.id !== 'undefined'
          ) {
            this.subscription.add(
              this.cartExtendService.saveAddressToCart(this.defaultBillingAddress.id, this.activeCartId).subscribe()
            );
            this.currentDeliveryAddress = this.defaultBillingAddress;
          }
        }
      });
    }
  }

  showAddress(addresses: any): Observable<string> {
    return this.myaccountPersonalInfoService.formatAddress(addresses);
  }

  get activeCartId() {
    let activeCartId: string;
    this.activeCart$.pipe(take(1)).subscribe((activeCart) => (activeCartId = activeCart));
    return activeCartId;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();

    if (this.hasChangedAddress$) {
      this.hasChangedAddress$.unsubscribe();
    }
  }
}
